<template>
  <div>
    <v-app-bar color="red" dark outlined app>
      <v-toolbar-title>Transaksi</v-toolbar-title>
    </v-app-bar>

    <v-main>
      <v-dialog
        ref="dialog"
        v-model="dateModal"
        :return-value.sync="dateTransactionList"
        persistent
        width="290px"
      >
        <template v-slot:activator="{ on, attrs }" class="ma-3">
          <v-text-field
            v-model="dateTransactionList"
            label="Tanggal Transaksi"
            prepend-icon="event"
            readonly
            v-bind="attrs"
            v-on="on"
            style="margin-top: 10px"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="dateTransactionList"
          scrollable
          :max="today"
          color="red"
        >
          <v-spacer></v-spacer>
          <v-btn text color="red" @click="dateModal = false">Kembali</v-btn>
          <v-btn
            text
            color="red"
            @click="$refs.dialog.save(dateTransactionList)"
            >Pilih</v-btn
          >
        </v-date-picker>
      </v-dialog>

      <!-- Skeleton -->
      <div v-if="isLoadingTx">
        <v-skeleton-loader
          class="mx-auto"
          type="list-item-two-line"
          v-for="i in 3"
          :key="i"
        />
      </div>

      <!-- Transaction List -->
      <div v-else>
        <v-list flat>
          <div v-for="tx in transactions.items" :key="tx.id">
            <v-list-item two-line @click="viewTransaction(tx)">
              <v-list-item-content>
                <v-list-item-title>{{ tx.invoice_number }}</v-list-item-title>
                <v-list-item-subtitle class="text-right">
                  Rp.&nbsp;{{ formatCurrency(tx.total_price) }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon :color="txStatus(parseInt(tx.status), 'color')">
                  info
                </v-icon>
              </v-list-item-icon>
            </v-list-item>
            <v-divider />
          </div>
        </v-list>
      </div>

      <!-- Transaction dialog -->
      <v-dialog id="transaction" v-model="showTransaction" fullscreen>
        <v-card>
          <v-toolbar dark color="red">
            <v-toolbar-title>Detail Transaksi</v-toolbar-title>
            <v-spacer />
            <v-btn icon dark @click="showTransaction = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>

          <div id="list-container">
            <!-- Skeleton -->
            <div v-if="isLoadingDetail">
              <v-skeleton-loader
                class="mx-auto"
                type="list-item-two-line"
                v-if="isLoadingDetail"
              />
            </div>

            <div v-else>
              <div class="ma-3">
                {{ localeDate(detailTransaction.created_at) }}
                <br />
                Status:
                {{ txStatus(parseInt(detailTransaction.status), "text") }}
                <br />
                <p
                  v-if="
                    parseInt(detailTransaction.status) ===
                    appConstant.TRANSACTION_INVALID
                  "
                >
                  Alasan: {{ detailTransaction.invalid_reason }}
                </p>
              </div>
              <v-divider />
              <v-list flat>
                <v-list-item
                  v-for="item in detailTransaction.transaction_items"
                  :key="item.id"
                  two-line
                >
                  <v-list-item-content>
                    <v-list-item-title>{{ item.menu.name }}</v-list-item-title>
                    <v-list-item-subtitle class="text-right">
                      {{ item.amount }} x Rp. {{ formatCurrency(item.price) }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-divider />
              </v-list>

              <!-- <div
              class="text-h6"
              style="padding-left: 12px"
              >Pelayan: {{detailTransaction.created_by_name}}</div>-->
              <div class="text-right text-h6" style="padding-right: 12px">
                Rp. {{ formatCurrency(detailTransaction.total_price) }}
              </div>

              <div
                class="ma-2"
                v-if="
                  parseInt(detailTransaction.status) !==
                  appConstant.TRANSACTION_INVALID
                "
              >
                <v-btn dark color="red" block @click="showInvalid = true">
                  Batalkan
                </v-btn>
              </div>

              <!-- Timeline transaksi -->
              <!-- <v-card flat class="mt-5">
              <v-card-title class="blue-grey white--text">
                <span class="title">Logs</span>
              </v-card-title>

              <v-timeline dense class="mx-2">
                <v-timeline-item color="red" small fill-dot>
                  <v-alert
                    color="red"
                    class="white--text"
                    v-if="detailTransaction.status == constant.TRANSACTION_INVALID"
                  >
                    {{detailTransaction.updated_at}}
                    <v-divider color="white"></v-divider>
                    Transaksi dibatalkan oleh: {{detailTransaction.created_by_name}}
                  </v-alert>

                  <v-alert color="red" class="white--text">
                    {{detailTransaction.created_at}}
                    <v-divider color="white"></v-divider>
                    Transaksi dibuat oleh: {{detailTransaction.created_by_name}}
                  </v-alert>
                </v-timeline-item>
              </v-timeline>
              </v-card>-->

              <v-dialog v-model="showInvalid">
                <v-card>
                  <v-card-title class="headline">
                    Batalkan Transaksi?
                  </v-card-title>

                  <v-form v-model="valid" ref="form">
                    <v-text-field
                      v-model="invalidReason"
                      label="Alasan pembatalan"
                      class="mx-3"
                      required
                      :rules="rules.required"
                      autocomplete="off"
                    />
                  </v-form>

                  <v-card-actions>
                    <v-btn color="red" dark @click="invalidTransaction">
                      Ya
                    </v-btn>
                    <v-spacer />
                    <v-btn color="black" dark @click="showInvalid = false">
                      Tidak
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </div>
        </v-card>
      </v-dialog>

      <!-- Overlay -->
      <v-overlay :value="showOverlay" z-index="9999">
        <v-progress-circular indeterminate size="64" />
      </v-overlay>

      <!-- Snackbar -->
      <v-snackbar v-model="showSnackbar" multi-line bottom>
        {{ textSnackbar }}
      </v-snackbar>
    </v-main>
  </div>
</template>

<script>
import EzKasirAPI from "@/library/api";
import common from "@/mixins/common";
import store from "@/store";
import moment from "moment";

export default {
  name: "Transaction",
  mixins: [common],
  data() {
    return {
      constant: store.state.constant,
      showTransaction: false,
      detailTransaction: {},
      transactions: {},
      isLoadingTx: true,
      isLoadingDetail: true,
      showInvalid: false,
      invalidReason: "",
      showOverlay: false,
      showSnackbar: false,
      textSnackbar: "",
      valid: false,
      rules: {
        required: [(v) => !!v || "Kolom wajib diisi"],
      },
      dateTransactionList: new Date().toISOString().substr(0, 10),
      dateModal: false,
    };
  },
  computed: {
    appConstant() {
      return store.state.constant;
    },
    today() {
      return new Date().toISOString().substr(0, 10);
    },
  },
  methods: {
    loadTransaction() {
      this.isLoadingTx = true;

      const filterDate = this.dateTransactionList.replace(/-/g, "");

      const url = `${process.env.VUE_APP_API_URL}/transaction/${this.user.store.id}?date=${filterDate}`;
      EzKasirAPI.get(url)
        .then((response) => {
          this.transactions = response.data.data;
        })
        .finally(() => {
          this.isLoadingTx = false;
        });
    },
    viewTransaction(tx) {
      this.detailTransaction = { ...tx };
      this.showTransaction = true;
      this.isLoadingDetail = true;

      const url = `${process.env.VUE_APP_API_URL}/transaction/detail/${this.detailTransaction.id}`;
      EzKasirAPI.get(url)
        .then((response) => {
          this.detailTransaction = response.data.data;
        })
        .finally(() => {
          this.isLoadingDetail = false;
        });
    },
    txStatus(status, type) {
      const color = this.appConstant;
      let s = [];

      if (status === color.TRANSACTION_IN_PROGRESS) {
        s = ["yellow", "Dalam Proses"];
      } else if (status === color.TRANSACTION_DONE) {
        s = ["green", "Selesai"];
      } else if (status === color.TRANSACTION_INVALID) {
        s = ["red", "Dibatalkan"];
      }

      return type === "color" ? s[0] : s[1];
    },
    invalidTransaction() {
      if (this.$refs.form.validate()) {
        this.showInvalid = false;
        this.showOverlay = true;
        const url = `${process.env.VUE_APP_API_URL}/transaction/invalid/${this.detailTransaction.id}`;

        EzKasirAPI.post(url, {
          reason: this.invalidReason,
        })
          .then(() => {
            this.textSnackbar = "Berhasil membatalkan transaksi";
          })
          .catch(() => {
            this.textSnackbar = "Gagal membatalkan transaksi";
          })
          .finally(() => {
            this.dissmissReload();
          });
      }
    },
    dissmissReload() {
      this.showSnackbar = true;
      this.showOverlay = false;
      this.showTransaction = false;
      this.loadTransaction();
    },
    localeDate(d) {
      const date = moment(d).format("DD MMM YYYY - HH:mm:ss");
      return date;
    },
  },
  created() {
    this.user = store.state.user;
    this.loadTransaction();
  },
  watch: {
    showInvalid() {
      this.$refs?.form?.reset();
      this.$refs?.form?.resetValidation();
    },
    dateModal(val) {
      if (!val) {
        this.loadTransaction();
      }
    },
  },
};
</script>

<style scoped>
</style>
